module.exports = __webpack_public_path__ + "img/car360.764d369e.png";